import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const verificationFormYupResolver = yupResolver(
  yup.object().shape({
    verifyCode: yup.string().required("請輸入驗證碼"),
  }),
);
